function initNavigation(e) {
  const navigationButton = e.target.closest('[data-cart-cross-sell-nav]');

  // Do not proceed if no navigation button was clicked.
  if (!navigationButton) {
    return;
  }

  const container = navigationButton.closest('[data-cart-cross-sell="cart-cross-sell-slider"]');

  // Do not proceed if no valid container was found.
  if (!container) {
    return;
  }

  const track = container.querySelector('[data-cart-cross-sell-track]');

  // Do not proceed if no track was found.
  if (!track) {
    return;
  }

  const slide = container.querySelector('[data-cart-cross-sell-slide]');

  // Measure slide width and add the flex gap so cards don't get clipped
  const slideWidth = slide ? Math.round(slide.getBoundingClientRect().width) : 350;

  // Get the gap between slides
  const trackStyle = window.getComputedStyle(track);
  const gap = parseFloat(trackStyle.gap) || 0;

  // Total scroll amount
  const scrollAmount = slideWidth + Math.round(gap);

  // Determine scroll direction
  const isPrev = navigationButton.dataset.cartCrossSellNavDirection === 'previous' ? true : false;

  // Perform the scroll
  track.scrollBy({
    left: isPrev ? -scrollAmount : scrollAmount,
    behavior: 'smooth'
  });
}

// Attach event listener
document.addEventListener("click", initNavigation);
